import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Packages from './pages/Packages';
import B2B from './pages/B2B';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import PackageDetail from './pages/PackageDetail';
import SpiritualPackageDetail from './pages/SpiritualPackageDetail';
import Services from './pages/Services';
import About from './pages/About';
import Spiritual from './pages/Spiritual';
import Gallery from './pages/Gallery';
import Footer from './components/Footer';
import InquiryWidget from './components/InquiryWidget';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:slug" element={<PackageDetail />} />
          <Route path="/spiritual" element={<Spiritual />} />
          <Route path="/spiritual/:slug" element={<SpiritualPackageDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/b2b" element={<B2B />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
        <InquiryWidget />
      </div>
    </Router>
  );
}

export default App;
